import axios from "axios";
import {BASE_URL, API_CUSTOMER_DOCUMENTS, API_CUSTOMER_DOCUMENTS_VERSION} from "./apiConstants";
import {keycloak} from "../keycloak";
import {ERROR_PAGE_500, ERROR_PAGE_504} from "../routes";
import {redirectLocale} from "../common";
import {useLogger} from "../../hooks/useLogger";

const {logger} = useLogger();

let apiInstance = axios.create({
    baseURL: (process.env.API_CUSTOMER_DOCUMENTS_BASE_URL || BASE_URL + API_CUSTOMER_DOCUMENTS) + API_CUSTOMER_DOCUMENTS_VERSION
});

apiInstance.interceptors.request.use((config) => {
    if (keycloak) {
        const token = keycloak.token || undefined;

        if (token) {
            keycloak.updateToken(process.env.KEYCLOAK_TOKEN_MIN_VALIDITY);
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    config.metadata = { startTime: new Date()};

    return config;
}, (err) => Promise.reject(err));

apiInstance.interceptors.response.use((response) => {
    return response;
}, function (error) {

    const xRequestID = error.request.getResponseHeader("x-request-id");

    error.config.metadata.endTime = new Date();
    error.duration = error.config.metadata.endTime - error.config.metadata.startTime;

    logger(error.message, "error", error.config?.baseURL?.slice(0, -1) + error.config?.url, error.stack, xRequestID, error.duration).then(() => {
        const pathname = window.location.pathname;
        const status = error?.response?.status;

        if(error.config.redirectOnError) {
            if (504 === status && !pathname.includes(ERROR_PAGE_504)) {
                window.location.href = redirectLocale(ERROR_PAGE_504) ;
            } else if (500 === status && !pathname.includes(ERROR_PAGE_504)) {
                window.location.href = redirectLocale(ERROR_PAGE_500) ;
            }
        }
    });

    return Promise.reject(error);
});

export const documentsAPI = apiInstance;
